import can_write_project from './can_write_project';

export default function (user, project) {
  if ('admin' === user.role) {
    return true;
  }

  if ((project.project_leads || []).includes(user.id)) {
    return true;
  }

  return (project.project_reviewers || []).includes(user.id);
}
